import React from 'react'
import { Link } from 'react-router-dom';

import "../../design/css/login.css";
import completeIcon from "../../assets/loginimg/completeicn.svg";
import teedexlogo from "../../assets/loginimg/teedexlogo.svg"
import logoutIcon from "../../assets/loginimg/logouticn.svg"

const ResetPassword = () => {
	return (
		<>
		 <div class="newLoginBody">
        <div class="newLoginBodyText">
            <div class="newLoginFormContainer newLoginFormBlock">
                <div class="mainImgLogin"><img src={completeIcon} alt="" /></div>
                <h1>Password reset</h1>
                <p>Your password has been successfully reset.<br/>Click below to log in Teedex.in</p>
                <div class="forgotPassword">
                    <Link to={"/login"}><img src={logoutIcon} alt="" /> Back to Login</Link>
                </div>
            </div>
            <div class="formTnc newLoginFormBlock">
                By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
            </div>
            <div class="formTeedexLogo newLoginFormBlock">
                <img src={teedexlogo} alt="Teedex Logo" />
            </div>
            <div class="formCopyR newLoginFormBlock">© 2024 Teedex All Rights Reserved</div>
        </div>

        <div class="newLoginBodyImg"></div>
    </div>
		</>
	)
}

export default ResetPassword